module.exports = __webpack_public_path__ + "static/img/Logo.15698f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo.png
// module id = YKfZ
// module chunks = 2